import type { SyncState } from '@kit/sync/types/sync-state';
import { useSyncExternalStore } from 'react';
import { replica } from './replica';

export function useSyncState(): SyncState {
  return useSyncExternalStore(replica.engine.subscribe, replica.engine.getState);
}
